import React, { useState } from "react";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import "./loginStyle.css";
import MailIcon from "@material-ui/icons/Mail";
import LockIcon from "@material-ui/icons/Lock";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import InputAdornment from "@material-ui/core/InputAdornment";
import Loading from "components/Loading/loading";
import DataService from "services/DataService";
import Cookie from "js-cookie";
import { useUser } from "../../context/userContext";
import { useAlert } from "../../context/Feedback/alertContext";
import Grid from "@material-ui/core/Grid";
import theme from "../Login/ButtonTheme.js";
import { ThemeProvider } from "@material-ui/core/styles";
import { useEffect } from "react";
import ErrorIcon from "@material-ui/icons/Error";
import logo from "../../assets/img/LogoCinza.svg";
//contants
import constants from "../../constants/Login/login";
import alertConstants from "../../constants/Feedback/alert";
import { useHistory } from "react-router-dom";
import IconButton from "@material-ui/core/IconButton";

export default function Login() {
  const [mail, setMail] = useState("");
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState("");
  const { setCredential, setUser, language, setIsAuth, setIsAdmin } = useUser();
  const { setAlert } = useAlert();
  const [errorMail, setErrorMail] = useState(false);
  const history = useHistory();
  useEffect(() => {
    if (mail) {
      try {
        let arroba = mail.split("@");

        if (arroba.length === 2) {
          let point = arroba[1].split(".");

          if (point.length >= 2 && point[1] !== "" && point[1] !== " ") {
            // Confirma se email existe no Login
            setErrorMail(false);
          } else {
            setErrorMail(true);
          }
        } else {
          setErrorMail(true);
        }
      } catch (e) {
        alert(e);
      }
    } else {
      setErrorMail(false);
    }
  }, [mail]);

  const checkAdmin = (data) => {
    for (let i = 0; i < data.roles.length; i++) {
      const element = data.roles[i];
      if (element.name === "ROLE_ADMIN") {
        setIsAdmin(true);
      }
    }
  };

  const handleLogin = async () => {
    try {
      if (password.length >= 4 && !errorMail) {
        setLoading(true);
        // const name = user.split("@")[0];
        let data = {
          email: mail,
          password: password,
          name: mail.split("@")[0],
        };
        const response = await DataService.signUp(data);

        const newData = {
          username: response.data.email,
          password: password,
          name: response.data.email,
        };

        const responseUser = await DataService.login(newData);
        setCredential(responseUser.headers.authorization);
        setUser(response.data);
        checkAdmin(response.data);
        Cookie.set("userMail", mail);
        Cookie.set("token", responseUser.headers.authorization);
        setIsAuth(true);
        setLoading(false);
        history.push("/user/automaton");
        const dateNow = new Date();

        const date =
          dateNow.getFullYear() +
          "-" +
          String(dateNow.getMonth()).padStart(2, "0") +
          "-" +
          String(dateNow.getMonth()).padStart(2, "0") +
          "T" +
          String(dateNow.getHours()).padStart(2, "0") +
          ":" +
          String(dateNow.getMinutes()).padStart(2, "0") +
          ":" +
          String(dateNow.getSeconds()).padStart(2, "0") +
          "Z";
        DataService.postLastAccess(mail, date, {
          headers: {
            Authorization: responseUser.headers.authorization,
          },
        }).then((responseUser) => {
          setUser(responseUser.data);
        });
      } else {
        setIsAuth(false);
        setLoading(false);
        setAlert({
          active: true,
          text: alertConstants.info.correctFill[language],
          color: "warning",
          sevarity: "error",
          icon: ErrorIcon,
        });
      }
    } catch (e) {
      setIsAuth(false);

      setLoading(false);
      setAlert({
        active: true,
        text: alertConstants.error.login[language],
        color: "danger",
        sevarity: "error",
        icon: ErrorIcon,
      });

      Cookie.remove("token");
      Cookie.remove("userMail");
    }
  };
  const handleSendNewPassword = async () => {
    if (!errorMail && mail.length > 0) {
      try {
        setLoading(true);
        await DataService.forgotPass(mail);
        setLoading(false);
        setAlert({
          active: true,
          text: alertConstants.info.sendPassword[language],
          color: "info",
          sevarity: "info",
          icon: ErrorIcon,
        });
      } catch (e) {
        setLoading(false);
        setAlert({
          active: true,
          text: alertConstants.error.sendPassword[language],
          color: "error",
          sevarity: "error",
          icon: ErrorIcon,
        });
      }
    } else {
      setAlert({
        active: true,
        text: alertConstants.warning.correctFill.sendPassword[language],
        color: "info",
        sevarity: "info",
        icon: ErrorIcon,
      });
    }
  };
  const _handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleLogin();
    }
  };

  return (
    <div className="container">
      <Grid
        container
        justifyContent="center"
        alignContent="center"
        alignItems="center"
        direction="column"
        style={{
          backgroundColor: "#FFF",
          borderRadius: "20px",
          width: "45%",
          height: "500px",
          boxShadow: "0 0 12px grey",
          position: "relative",
        }}
      >
        {/* Usar IconButton para o ícone de voltar */}
        <IconButton
          style={{
            color: "black",
            position: "absolute",
            left: "20px",
            top: "20px",
          }}
          onClick={() => {
            window.open("/user/about", "_self");
          }}
        >
          <ArrowBackIcon />
        </IconButton>
        <div className="wrapper-login">
          <img src={logo}></img>
        </div>
        <Loading loading={loading} />
        <form className="wrapper-inputs">
          <ThemeProvider theme={theme.themeInput}>
            <TextField
              onKeyDown={(event) => _handleKeyDown(event)}
              label={constants.inputs.username[language]}
              variant="filled"
              error={errorMail}
              onChange={(el) => {
                setMail(el.target.value);
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <MailIcon style={{ color: "#FFF" }} />
                  </InputAdornment>
                ),
              }}
              autoComplete="username"
              id="email-input"
              name="email"
            />
            <TextField
              onKeyDown={(event) => _handleKeyDown(event)}
              label={constants.inputs.password[language]}
              variant="filled"
              type="password"
              onChange={(el) => {
                setPassword(el.target.value);
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <LockIcon style={{ color: "#FFF" }} />
                  </InputAdornment>
                ),
              }}
              autoComplete="current-password"
              id="password-input"
              name="password"
            />
          </ThemeProvider>
          <div className="forget-pass">
            <h3
              onClick={handleSendNewPassword}
              style={{
                marginTop: 0,
                fontSize: 12,
                color: "#24232B",
                cursor: "pointer",
              }}
            >
              {constants.span.forgetPassword[language]}
            </h3>
          </div>
        </form>

        <ThemeProvider theme={theme.themeButton}>
          <Button
            style={{
              width: "40%",
              height: "50px",
              color: "#FFF",
              borderRadius: "10px",
            }}
            onClick={handleLogin}
          >
            {constants.button[language]}
          </Button>
        </ThemeProvider>
        <div className="div-span-login">
          <span style={{ margin: "auto" }}>
            {constants.span.spanRegister1[language]}{" "}
            <span style={{ color: "#24232B" }}>
              {constants.span.register[language]}
            </span>{" "}
            {constants.span.spanRegister2[language]}
          </span>
        </div>
      </Grid>
    </div>
  );
}
